import { render, staticRenderFns } from "./marking-light-source.form.vue?vue&type=template&id=962d5722&"
import script from "./marking-light-source.form.vue?vue&type=script&lang=ts&"
export * from "./marking-light-source.form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports